/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";

import Typography from "@mui/material/Typography";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";

import { APPROVER_SELECTION_REQUIRED } from "../../Constants";

import { useScreenSize, ZINDEX_FOOTER } from "../Theme";

export const DEFAULT_APPROVER: Approver = { id: "", name: "指定なし" };

export const DUMMY_APPROVERS = {
    approver: DEFAULT_APPROVER,
    approverList: [],
} as ApproverSelect;

export interface Approver {
    id: string;
    name: string;
}

export interface ApproverSelect {
    approver?: Approver;
    approverList?: Approver[];
}

export interface ApproverSelectionContainerProps {
    show: boolean;
    approver1?: Approver;
    approverList1?: Approver[];
    handleChangeApprover1?: (event: SelectChangeEvent) => void;
    approver2?: Approver;
    approverList2?: Approver[];
    handleChangeApprover2?: (event: SelectChangeEvent) => void;
}

interface ApproverSelectionProps {
    title: string;
    approverList?: Approver[];
    approver?: Approver;
    handleChangeApprover?: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
}

export const isNeedApprove = (needApprove: number) => needApprove === APPROVER_SELECTION_REQUIRED;

const ApproverSelection = (props: ApproverSelectionProps) => {
    // Props.
    const { title, approverList, approver, handleChangeApprover } = props;

    // Hooks
    const { desktop } = useScreenSize();

    // 承認者リストが空の場合は非表示
    if (!approverList || !approverList.length) return <></>;

    // Render component.
    return (
        <Grid item container direction="column" flexWrap="nowrap" justifyContent="flex-start">
            <Typography variant="body2">{title}</Typography>
            <Select
                {...(desktop && { size: "small" })}
                displayEmpty
                sx={{ width: "100%" }}
                value={approver?.id}
                onChange={handleChangeApprover}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                    transformOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                    PaperProps: { sx: { maxHeight: "60%" } },
                    sx: { zIndex: ZINDEX_FOOTER + 1 },
                }}
            >
                {approverList.map((item, index) => (
                    <MenuItem value={item.id} key={item.id + index}>
                        <Typography
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {item.name}
                        </Typography>
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );
};

export const ApproverSelectionContainer = (props: ApproverSelectionContainerProps) => {
    // Props.
    const { show, approverList1, approver1, handleChangeApprover1, approverList2, approver2, handleChangeApprover2 } = props;
    // console.log("ApproverSelectionContainer", props);

    // Logics.
    if (!show) return <></>;

    // Render component.
    return (
        <Grid item container direction="column" rowSpacing={1} justifyContent="center" sx={{ width: "100%", pt: 1 }}>
            <ApproverSelection title="1段階承認者" approverList={approverList1} approver={approver1} handleChangeApprover={handleChangeApprover1} />
            <ApproverSelection title="2段階承認者" approverList={approverList2} approver={approver2} handleChangeApprover={handleChangeApprover2} />
        </Grid>
    );
};
